module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("\n\t\t\t\t \n\t\t\t")]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "background-color": "#f8f8f9",
      "border-radius": "5%"
    },
    attrs: {
      "span": "12"
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('Row', [_c('Col', [_c('label', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "font-family": "'Helvetica Neue'"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tUpdate 2-Factor Authentication\n\t\t\t\t\t\t\t")])])], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "30px"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#41B8BC",
      "font-size": "16px"
    }
  }, [_vm._v("Step 1. ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Install the Google Authenticator app on your phone.")])]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "span": "4"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": require("../../../static/img/google_authenticator.jpg")
    }
  })]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "margin-top": "30px",
      "font-size": "16px"
    },
    attrs: {
      "span": "10"
    }
  }, [_c('label', [_vm._v("IOS        ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-family": "Helvetica",
      "color": "#41B8BC"
    },
    attrs: {
      "href": "https://itunes.apple.com/cn/app/google-authenticator/id388497605",
      "target": "_blank"
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('label', [_vm._v(" | ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-family": "Helvetica",
      "color": "#41B8BC"
    },
    attrs: {
      "href": "https://bigone.zendesk.com/hc/zh-cn/articles/115004699233",
      "target": "_blank"
    }
  }, [_vm._v("User Guide")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Android  ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-family": "Helvetica",
      "color": "#41B8BC"
    },
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
      "target": "_blank"
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('label', [_vm._v(" | ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-family": "Helvetica",
      "color": "#41B8BC"
    },
    attrs: {
      "href": "https://bigone.zendesk.com/hc/zh-cn/articles/115004714734",
      "target": "_blank"
    }
  }, [_vm._v("User Guide")])])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "30px"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#41B8BC",
      "font-size": "16px"
    }
  }, [_vm._v("Step 2. ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Scan the QR code below with the authenticator app.")])]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "span": "4"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "160px",
      "height": "160px"
    },
    attrs: {
      "src": _vm.qrcode
    }
  })])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "30px"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#41B8BC",
      "font-size": "16px"
    }
  }, [_vm._v("Step 3. ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Write down this secret key and keep it in a safe place:")])]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "100px",
      "margin-top": "20px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v(_vm._s(_vm.formCustom.authenticationSecret))]), _vm._v("  \n                    "), _c('Icon', {
    staticClass: "secretKey",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "ios-copy-outline",
      "size": "20",
      "title": "Copy secret key",
      "data-clipboard-text": this.formCustom.authenticationSecret,
      "color": "#41B8BC"
    },
    on: {
      "click": _vm.copySecretKey
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("It may take up to "), _c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("7 business days")]), _vm._v(" if you try to restore 2FA without this key (e.g. your phone got lost or erased).")])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "30px"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#41B8BC",
      "font-size": "16px"
    }
  }, [_vm._v("Step 4. ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Enter the 6-digit code displayed on your authenticator app below:")])]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "100px",
      "margin-top": "30px"
    }
  }, [_c('Form', {
    ref: "formCustom",
    attrs: {
      "model": _vm.formCustom,
      "rules": _vm.ruleCustom
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "randomCode"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100px",
      "height": "30px",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "placeholder": "000000",
      "size": "large",
      "maxlength": 6
    },
    model: {
      value: (_vm.formCustom.randomCode),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "randomCode", $$v)
      },
      expression: "formCustom.randomCode"
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "30px",
      "background": "#41B8BC"
    },
    attrs: {
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formCustom')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Helvetica",
      "color": "#FFFFFF"
    }
  }, [_vm._v("Submit")])])], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "id"
    }
  }, [_c('Input', {
    attrs: {
      "type": "hidden",
      "disabled": ""
    },
    model: {
      value: (_vm.formCustom.id),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "id", $$v)
      },
      expression: "formCustom.id"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "authenticationSecret"
    }
  }, [_c('Input', {
    attrs: {
      "type": "hidden",
      "disabled": ""
    },
    model: {
      value: (_vm.formCustom.authenticationSecret),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "authenticationSecret", $$v)
      },
      expression: "formCustom.authenticationSecret"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "qrcode"
    }
  }, [_c('Input', {
    attrs: {
      "type": "hidden",
      "disabled": ""
    },
    model: {
      value: (_vm.formCustom.qrcode),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "qrcode", $$v)
      },
      expression: "formCustom.qrcode"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("\n\t\t\t\t \n\t\t\t")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8c966b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/ResetAuthentication.vue
// module id = 471
// module chunks = 0